/**
 * @desc パラメーターの値を取得します。
 * @param {String} key - パラメーターのキー。
 * @return {String} - 存在しない場合は空の文字列を、存在する場合は`foo=1`の`1`だけを返す。
 * @example
 * import getParameter from './getParameter';
 * const KEY = 'key';
 * const keyParameter = getParameter(KEY);
 */
export default function getParameter(key) {
  const locationSearch = window.location.search.substring(1);
  const hasParamter = !!locationSearch.length;

  if (!hasParamter) return '';

  const targetParameter = locationSearch.split('&').filter(parameter => {
    return parameter.split('=')[0] === key;
  });

  if (targetParameter.length) {
    const targetValue = targetParameter[0].split('=')[1];
    return targetValue;
  }

  return '';
}
